{
  "unsubscribe_title": "Annulla l'iscrizione alle email",
  "unsubscribe_message": "Dispiace vederti andare.",
  "unsubscribe": "Annulla iscrizione",
  "cancel": "Annulla",
  "passwordResetSuccess": "La tua password è stata cambiata con successo.",
  "passwordResetError": "Purtroppo, si è verificato un problema",
  "passwordResetExpired": "Questo link non è valido o è scaduto. Richiedi una nuova e-mail per reimpostare la password.",
  "passwordResetTitle": "Imposta una nuova password",
  "new_password": "Nuova password",
  "confirm_password": "Conferma nuova password",
  "save": "Salva",
  "error": "Purtroppo, si è verificato un problema",
  "unsubscribeSuccess": "L'azione è stata eseguita con successo",
  "emailChangeLoading": "Cambio email in corso...",
  "emailChangeSuccess": "L'email è stata modificata con successo",
  "emailChangeError": "Purtroppo, si è verificato un problema nel cambiare l'email",
  "home": {
    "tagline": "Oltre 1 milione di proprietari di cani si allenano con Hundeo",
    "subline": "Consigliata da veri addestratori cinofili",
    "appStorePrefix": "Scarica su",
    "playStorePrefix": "Disponibile su",
    "qrHint": "Apri l'app sul tuo telefono",
    "qrCaption": "Inquadra il codice con la fotocamera",
    "socialProof": "5.000+ recensioni a 5 stelle",
    "imprint": "Impronta",
    "privacy": "Privacy",
    "language": "Lingua",
    "openWebsite": "Vai al sito",
    "openInApp": "Apri nell'app Hundeo",
    "openInAppHint": "Verrai portato alla tua app",
    "openInAppButton": "Apri",
    "promoRedirectTitle": "Stiamo aprendo la tua offerta …",
    "promoRedirectButton": "Vai alla tua offerta"
  }
}
